import styled, { DefaultTheme, css } from 'styled-components';
import { Div } from '../helpers/StyledUtils';

type Colors = keyof DefaultTheme['colors']['on']['hue_container'];

export const StatusDot = styled(Div)<{
  color: Colors;
}>(
  ({ theme, color }) => css`
    content: '';
    height: 8px;
    width: 8px;
    border-radius: 50%;
    margin: ${theme.spacing(1)};
    background-color: ${theme.colors.on.hue_container[color]};
  `,
);
